<template>
  <UIDialog :z-index :is-open title="Import repository" @close="handleClose">
    <RepositoryImportForm @close="handleClose" />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import RepositoryImportForm from './components/ImportForm.vue'
import { UIDialog } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
}
const props = defineProps<Props>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
}
</script>
